export default "__VITE_ASSET__BAJSZD21__"